import axios from 'axios'
import {
  RecaptchaVerifier,
  getAuth,
  signInWithPhoneNumber,
} from 'firebase/auth'
import React, { useEffect, useRef, useState } from 'react'
import 'react-phone-number-input/style.css'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import DashboardLayout from '../../../components/ui/DashboardLayout'
import Loading from '../../../components/ui/Loading'
import { Copy, Cross } from '../../../components/ui/Swicons'
import { app } from '../../../firebase'
import { VerificationSteps, devURL } from '../../../utils'
// import Api from "../../../Api";
import { Dialog } from '@headlessui/react'
import { Step, StepLabel, Stepper } from '@mui/material'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from 'react-phone-number-input'
import {
  recoverUser as DfnsRecoverUser,
  addRecoveryKeys,
  createTrustLine,
  createWallet,
  login,
  register,
} from '../../../Api/index'
import { sendAnalyticsEvent } from '../../../analytics'
import HelpTooltip from '../../../components/ui/HelpTooltip'
const { getName, getCode } = require('country-list')

const MyProfile = () => {
  const token = localStorage.getItem('swToken')
  const [loader, isLoading] = useState(true)
  const [openAddNumberDialog, setOpenAddNumberDialog] = useState(false)
  const [editedName, setEditedName] = useState('')
  const [userProData, setUserProfileData] = useState([])
  const [userEmail, setUserEmail] = useState()
  const [userDfnsId, setUserDfnsId] = useState()
  const [userDfnsWallet, setUserDfnsWallet] = useState()
  const [wallet, setWallet] = useState()
  const [userDfnsRecoveryId, setUserDfnsRecovery] = useState('')
  const [oldEmail, setOldEmail] = useState()
  const [userEmailEdit, setUserEmailEdit] = useState(true)
  const [userNameEdit, setUserNameEdit] = useState(true)
  const [clientId, setClientId] = useState('')
  const [fullName, setFullName] = useState('')
  const [authToken, setAuthToken] = useState('')
  const [showIframe, setShowIframe] = useState(false)
  const [stepperState, setStepperState] = useState(0)
  const [url, setUrl] = useState('')
  const [status, setStatus] = useState('')
  const [scanRef, setScanRef] = useState('')
  const [hasClicked, setHasClicked] = useState(false)
  const navigate = useNavigate()
  const kycButtonRef = useRef(null)
  const dfnsButtonRef = useRef(null)
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()

  const fromDashboard = searchParams.get('fromDashboard')

  useEffect(() => {
    getUserProfileData()
  }, [])

  const removeSearchParam = () => {
    if (fromDashboard) {
      searchParams.delete('fromDashboard')
      setSearchParams(searchParams)
    }
  }

  // status = 'REVIEWING'
  const isEmailVerified = userProData.is_verified || false
  const isDocSubmitted = userProData.doc_submitted || false
  const isPhoneVerified = true // userProData.phoneNumberVerified || false
  const isOnRampKycVerified = userProData.onRampMoneyKyc || false
  const isButtonDisabled =
    (isDocSubmitted && !isOnRampKycVerified) || status == 'REVIEWING'
  // (isDocSubmitted && (status == 'REVIEWING' || !isOnRampKycVerified)) || false

  useEffect(() => {
    if (userProData) {
      if (
        isEmailVerified &&
        isDocSubmitted &&
        isOnRampKycVerified &&
        isPhoneVerified
      ) {
        setStepperState(3)
      } else if (isEmailVerified && isPhoneVerified) {
        setStepperState(2)
      } else if (isEmailVerified) {
        setStepperState(1)
      } else {
        setStepperState(0)
      }
    }
  }, [userProData])

  const handleVerify = () => {
    if (stepperState === 0) {
      resendEmailVerify()
    } else if (stepperState === 1) {
      setOpenAddNumberDialog(true)
    } else if (stepperState === 2) {
      handleKyc()
    } else if (stepperState === 3) {
      if (!userProData.dfns_wallet_id) {
        createDfnsAccount()
      } else if (
        !wallet.active &&
        wallet.type === 'stellar' &&
        wallet.xlm_sent &&
        !wallet.usdc_trust_line
      ) {
        initiateWalletActivation()
      }
    } else {
      toast.error('Wallet already created contact support')
    }
  }

  const initiateWalletActivation = async () => {
    try {
      isLoading(true)
      await createTrustLine()
    } catch (e) {
      toast.error(
        'Failed to Activate Wallet, try again with the same device as used to create wallet'
      )
    } finally {
      isLoading(false)
      getUserProfileData()
    }
  }

  const createDfnsAccount = async () => {
    isLoading(true)
    try {
      setHasClicked(true)
      removeSearchParam()
      await register(userEmail)
      await login(userEmail)
      getUserProfileData()
      toast.success('Wallet created successfully.')
    } catch (error) {
      isLoading(false)
      sendAnalyticsEvent('error', {
        category: 'DFNS',
        action: 'Create Wallet',
        label: 'Failed',
      })
      console.error('Error creating Wallet:', error)
      toast.error('Please try again after sometime')
    }
    isLoading(false)
  }

  const createDfnswallet = async () => {
    isLoading(true)
    try {
      setHasClicked(true)
      removeSearchParam()
      await createWallet()
      getUserProfileData()
      toast.success('Wallet verification successful.')
    } catch (error) {
      isLoading(false)
      console.error('Error in verifying wallet:', error)
      toast.error('Please try again after sometime')
      sendAnalyticsEvent('error', {
        category: 'DFNS',
        action: 'Verify Wallet',
        label: 'Failed',
      })
    }
    isLoading(false)
  }
  const recoverUser = async (data) => {
    isLoading(true)
    try {
      let res = await DfnsRecoverUser(data)
      getUserProfileData()
      if (res.error) {
        throw new Error(res.error)
      }
      toast.success('User recovery successful.')
    } catch (error) {
      isLoading(false)
      console.error('Error in recover user', error)
      toast.error('Please try again after sometime')
      sendAnalyticsEvent('error', {
        category: 'DFNS',
        action: 'Recover User',
        label: 'Failed',
      })
    }
    isLoading(false)
  }
  const addDFNSRecoveryKeys = async (data) => {
    isLoading(true)
    try {
      let res = await addRecoveryKeys(data)
      getUserProfileData()
      if (res.error) {
        throw new Error(res.error)
      }
      toast.success('User recovery key added.')
    } catch (error) {
      isLoading(false)
      console.error('Error in recover user', error)
      toast.error('Please try again after sometime')
    }
    isLoading(false)
  }

  const handleAddDevice = async () => {
    try {
      Swal.fire({
        title: 'Link More Devices to Your Digital Wallet!',
        html: '<p>Click the button below to add additional devices, ensuring seamless access to your digital wallet wherever you go.</b>',
        showDenyButton: true,
        confirmButtonColor: '#2878bb',
        denyButtonColor: '#a4a4a4',
        denyButtonText: 'Later',
        confirmButtonText: 'Sure',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/new-device')
        }
        if (result.isDenied) {
          navigate('/myprofile')
        }
      })
    } catch (error) {
      console.error('Error adding device:', error)
      toast.error('Failed to add device.')
    }
  }

  const getUserProfileData = async () => {
    axios
      .get(`${devURL}/user/get-user-info`, {
        headers: { token: token },
      })
      .then((res) => {
        if (res.data) {
          setClientId(res.data._id)
          setUserProfileData(res.data)
          setEditedName(res.data.full_name)
          setUserEmail(res.data.email)
          setOldEmail(res.data.email)
          setFullName(res.data.full_name)
          setUserDfnsId(res.data.dfns_user_id)
          setUserDfnsWallet(res.data.dfns_wallet_id)
          setUserDfnsRecovery(res.data.dfns_recovery_credential_id ?? '')
          if (hasClicked) {
            navigate('/myprofile')
          }
          if (!res.data.doc_submitted) {
            createResponse()
          } else {
            isLoading(false)
          }
          if (
            fromDashboard === 'dfns' &&
            dfnsButtonRef.current &&
            !hasClicked
          ) {
            dfnsButtonRef.current.click()
          }
        }
      })
      .catch((err) => {
        console.log(err)
      })
    try {
      const walletReq = await axios.get(`${devURL}/dfns/wallets`, {
        headers: { token: token },
      })
      setWallet(walletReq.data)
    } catch (e) {}
  }
  const handleChange = (e) => {
    setUserEmail(e.target.value)
  }

  const handleNameChange = (e) => {
    setEditedName(e.target.value)
  }
  const editEmail = (event) => {
    if (event === 'edit') {
      setUserEmailEdit(false)
    } else {
      setUserEmail(oldEmail)
      setUserEmailEdit(true)
    }
  }

  const editName = (event) => {
    if (event === 'edit') {
      setUserNameEdit(false)
    } else if (event === 'save') {
      if (editName === '') {
        toast.error('Please enter your full name.')
      } else {
        axios
          .post(
            `${devURL}/user/update-name`,
            { full_name: editedName },
            { headers: { token: token } }
          )
          .then((response) => {
            if (response.data.status) {
              setUserNameEdit(true)
              setFullName(editedName)
              Swal.fire({
                icon: 'success',
                text: `Name changed successfully`,
              })
            } else {
              Swal.fire(`Entered name not updated!`)
            }
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.errorMessage
            ) {
              toast.error(`${error.response.data.errorMessage}`)
              //Swal.fire(`Request failed: ${error.response.data.errorMessage}`);
            }
          })
      }
      //handle cancel
    } else {
      setUserNameEdit(true)
      setEditedName(fullName)
    }
  }

  const resendEmailVerify = () => {
    async function callApi() {
      await axios
        .post(
          `${devURL}/user/send-activation-email`,
          { email: userEmail },
          { headers: { token: token } }
        )
        .then((res) => {
          if (res.data.status) {
            Swal.fire(res.data.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
    callApi()
  }

  async function createIdentificationToken() {
    const response = await axios
      .post(
        `${devURL}/user/kyc`,
        {
          clientId: clientId,
          firstName: fullName.split(' ').slice(0, -1).join(' '),
          lastName: fullName.split(' ').slice(-1).join(' '),
          expiryTime: 1200,
          documents: [
            'PASSPORT',
            'ID_CARD',
            'DRIVER_LICENSE',
            'RESIDENCE_PERMIT',
          ],
        },
        { headers: { token: token } }
      )
      .then((response) => {
        axios.post(
          `${devURL}/user/sendKyc`,
          {
            user_email: userEmail,
            url: 'https://ui.idenfy.com/?authToken=' + response.data.authToken,
          },
          { headers: { token: token } }
        )
        setAuthToken(response.data.authToken)
        setScanRef(response.data.scanRef)
        setUrl('https://ui.idenfy.com/?authToken=' + response.data.authToken)
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errorMessage
        ) {
          toast.error(`${error.response.data.errorMessage}`)
          //Swal.fire(`Request failed: ${error.response.data.errorMessage}`);
        }
      })
  }

  async function handleKyc() {
    createIdentificationToken()
    Swal.fire({
      title: 'Please complete the verification process within 20 minutes',
      html: '<p>We have also sent the link to your email address.</p><br/><b>Note: You can close the screen once the verification starts</b>',
      showDenyButton: true,
      confirmButtonColor: '#2878bb',
      denyButtonColor: '#a4a4a4',
      denyButtonText: 'Later',
    }).then((result) => {
      if (result.isConfirmed) {
        setShowIframe(true)
      }
      if (result.isDenied) {
        navigate('/myprofile')
      }
    })
  }

  async function createResponse() {
    axios
      .get(`${devURL}/user/idenfy`, {
        headers: { token: token },
      })
      .then((res) => {
        isLoading(false)
        setStatus(res.data)
        console.log(res.data)
        setShowIframe(false)
        if (fromDashboard == 'kyc' && kycButtonRef.current) {
          kycButtonRef.current.click()
        }
      })
  }

  const updateEmail = () => {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    if (userEmail === '') {
      toast.error('Please enter your email address.')
      isLoading(false)
    } else if (!userEmail.match(mailformat)) {
      toast.error('You have entered an invalid email address!.')
      isLoading(false)
    } else {
      const { value: password } = Swal.fire({
        title: 'Enter your password!',
        input: 'password',
        inputValue: '',
        inputPlaceholder: 'Enter your password*',
        showCancelButton: true,
        confirmButtonText: 'Update',
        confirmButtonColor: '#2878bb',
        cancelButtonColor: '#EA0000',
        inputValidator: (value) => {
          if (!value) {
            return 'You need to enter profile password!'
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(
              `${devURL}/user/update-email`,
              { password: result.value, email: userEmail },
              { headers: { token: token } }
            )
            .then((response) => {
              if (response.data.status) {
                setUserEmail(userEmail)
                setOldEmail(userEmail)
                setUserEmailEdit(true)
                Swal.fire({
                  icon: 'success',
                  text: `Entered ${response.data.message}`,
                })
              } else {
                Swal.fire(`Entered email not updated!`)
              }
            })
            .catch((error) => {
              if (
                error.response &&
                error.response.data &&
                error.response.data.errorMessage
              ) {
                toast.error(`${error.response.data.errorMessage}`)
                //Swal.fire(`Request failed: ${error.response.data.errorMessage}`);
              }
            })
        } else if (result.isDismissed) {
          setUserEmail(oldEmail)
          setUserEmailEdit(true)
        }
      })
    }
  }

  return (
    <DashboardLayout>
      {loader ? (
        <Loading />
      ) : (
        <div className='h-full w-full'>
          {showIframe ? (
            <div className='h-full w-full'>
              <button
                onClick={createResponse}
                className='float-right pr-8 mb-4 -mt-8'
              >
                <Cross />
              </button>
              <iframe
                id='iframe'
                allowFullScreen
                className='w-full h-full'
                src={url}
                allow='camera'
              ></iframe>
            </div>
          ) : (
            <>
              <div className='flex items-center lg:-ml-0 font-bold text-xl page-title leading-8 justify-center'>
                {/* <span clas="text-green-500">
                <PersonIcon />
              </span> */}
                <span className='tracking-wide'>About Me {/* Profile */}</span>
              </div>
              <div className='my-10 flex items-center justify-center '>
                <div className='bg-white px-3 py-6 shadow-lg rounded-sm justify-center sw-shadow ml-4 w-3/4 xl:w-2/5 lg:ml-0'>
                  <div className='text-gray-700 text-lg'>
                    <div className='grid md:grid-cols-1 text-sm items-center gap-1'>
                      <div className='grid grid-cols-2 lg:grid-cols-3 items-baseline'>
                        <div className='grid-cols-1 px-4 py-2 font-semibold'>
                          Full Name
                        </div>
                        <div className='px-4 py-2 -ml-16 lg:-ml-0'>
                          {userNameEdit && (
                            <a className='text-blue-800'>{editedName}</a>
                          )}
                          {!userNameEdit && (
                            <input
                              name='updateemail'
                              type='email'
                              onChange={handleNameChange}
                              placeholder='Enter New name'
                              className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                              value={editedName}
                            />
                          )}
                        </div>
                        <div className='px-0 py-2 flex justify-center ml-4 lg:ml-0'>
                          {userNameEdit && !userProData.doc_submitted && (
                            <button
                              onClick={() => editName('edit')}
                              data-test='change'
                              className='group relative ml-4 -mb-8 py-1 w-32 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                              // style={{ backgroundColor: "#5C6E64" }}
                            >
                              Change
                            </button>
                          )}
                          {!userNameEdit && (
                            <span className='flex ml-12 lg:ml-0'>
                              <button
                                onClick={() => editName('save')}
                                className='group relative py-1 px-4 border border-transparent text-sm font-medium rounded-md text-white  bg-themeColor hover:bg-themeHover'
                              >
                                Update
                              </button>
                              <button
                                onClick={() => editName('cancel')}
                                className='group relative py-1 px-4 border border-transparent text-sm font-medium rounded-md text-white ml-2'
                                style={{ backgroundColor: 'rgb(221 31 67)' }}
                              >
                                Cancel
                              </button>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className='grid grid-cols-2 lg:grid-cols-3 items-baseline'>
                        <div className='grid-cols-1 px-4 py-2 font-semibold'>
                          Email
                        </div>
                        <div className='px-4 py-2 -ml-16 lg:-ml-0'>
                          {userEmailEdit && (
                            <a className='text-blue-800'>{userEmail}</a>
                          )}
                          {!userEmailEdit && (
                            <input
                              name='updateemail'
                              type='email'
                              onChange={handleChange}
                              placeholder='Enter New email'
                              className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                              value={userEmail}
                            />
                          )}
                        </div>
                        <div className='px-0 py-2 flex justify-center ml-4 lg:ml-0'>
                          {userEmailEdit && (
                            <button
                              onClick={() => editEmail('edit')}
                              data-test='change'
                              className='group relative ml-4 py-1 w-32 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                              // style={{ backgroundColor: "#5C6E64" }}
                            >
                              Change
                            </button>
                          )}
                          {!userEmailEdit && (
                            <span className='flex ml-12 lg:ml-0'>
                              <button
                                onClick={updateEmail}
                                className='group relative py-1 px-4 border border-transparent text-sm font-medium rounded-md text-white  bg-themeColor hover:bg-themeHover'
                              >
                                Update
                              </button>
                              <button
                                onClick={() => editEmail('cancel')}
                                className='group relative py-1 px-4 border border-transparent text-sm font-medium rounded-md text-white ml-2'
                                style={{ backgroundColor: 'rgb(221 31 67)' }}
                              >
                                Cancel
                              </button>
                            </span>
                          )}
                        </div>
                      </div>
                      {userProData.country !== 'Unknown' ? (
                        <div className='grid grid-cols-3'>
                          <div className='grid-cols-1 px-4 py-2 font-semibold'>
                            Country
                          </div>
                          <div className='px-4 py-2'>{userProData.country}</div>
                        </div>
                      ) : null}
                      {userProData.phoneNumberVerified &&
                      userProData.phoneNumber ? (
                        <div className='grid grid-cols-3'>
                          <div className='grid-cols-1 px-4 py-2 font-semibold'>
                            Phone Number
                          </div>
                          <div className='px-4 py-2'>
                            {userProData.phoneNumber}
                          </div>
                        </div>
                      ) : null}

                      <div className='grid grid-cols-3 py-2'>
                        <div className='grid-cols-1 px-4 py-2 font-semibold'>
                          Deposit Code
                        </div>
                        <div className='flex px-4 py-2'>
                          <div>{userProData.deposit_code}</div>
                          <div className='h-4'>
                            <CopyToClipboard
                              text={userProData.deposit_code}
                              onCopy={() => toast.success('Copied!')}
                            >
                              <button style={{ marginLeft: '1rem' }}>
                                <Copy />
                              </button>
                            </CopyToClipboard>
                          </div>
                        </div>
                      </div>
                      {/* <div className='grid grid-cols-3'>
                        <div className='grid-cols-1 px-4 py-2 font-semibold'>
                          Email Verified
                        </div>
                        <div className='px-2 py-1'>
                          {userProData.is_verified === true ? (
                            <CheckCircleIcon />
                          ) : (
                            <XCircleIcon />
                          )}
                        </div>
                        <div className='-ml-12 lg:-ml-24 px-0 py-0'>
                          {userProData.is_verified === false && (
                            <button
                              onClick={resendEmailVerify}
                              className='group relative py-1 mt-2 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                              // style={{ backgroundColor: "#5C6E64" }}
                            >
                              Verify
                            </button>
                          )}
                        </div>
                      </div> */}
                      {/* dfns */}
                      <div className='grid grid-cols-3'>
                        {(userDfnsId !== '' &&
                          userDfnsWallet != '' &&
                          !userDfnsRecoveryId) ||
                          (userDfnsId !== '' && userDfnsRecoveryId != '' && (
                            <div className='grid-cols-1 flex gap-2 px-4 py-2 font-semibold'>
                              <div>Digital Wallet</div>
                              <div>
                                <HelpTooltip
                                  tooltipText={'Secures your transactions'}
                                  height='12px'
                                />
                              </div>
                            </div>
                          ))}
                        {/* <div className='px-2 py-1'>
                          {userDfnsId !== '' &&
                          userDfnsWallet !== '' &&
                          userDfnsRecoveryId ? (
                            <CheckCircleIcon />
                          ) : (
                            <XCircleIcon />
                          )}
                        </div> */}
                        <div className=' px-0 py-0'>
                          {/* {userDfnsId === '' && (
                            <button
                              onClick={createDfnsAccount}
                              ref={dfnsButtonRef}
                              className='group relative py-1 mt-2 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                              // style={{ backgroundColor: "#5C6E64" }}
                            >
                              Create wallet
                            </button>
                          )}
                          {userDfnsId !== '' && userDfnsWallet == '' && (
                            <button
                              onClick={createDfnswallet}
                              ref={dfnsButtonRef}
                              className='group relative py-1 mt-2 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                              // style={{ backgroundColor: "#5C6E64" }}
                            >
                              Verify wallet
                            </button>
                          )} */}
                          {userDfnsId !== '' &&
                            userDfnsWallet != '' &&
                            !userDfnsRecoveryId && (
                              <button
                                onClick={() => {
                                  addDFNSRecoveryKeys(userEmail)
                                }}
                                className='group relative py-1 mt-2 px-2 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                                // style={{ backgroundColor: "#5C6E64" }}
                              >
                                Setup Recovery Key
                              </button>
                            )}
                          {userDfnsId !== '' && userDfnsRecoveryId != '' && (
                            <button
                              onClick={() => {
                                recoverUser(userEmail)
                              }}
                              className='group relative py-1 mt-1 w-32 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                              // style={{ backgroundColor: "#5C6E64" }}
                            >
                              Recover account
                            </button>
                          )}
                        </div>
                      </div>

                      {userDfnsWallet !== '' && (
                        <div className='grid grid-cols-3'>
                          <div className='grid-cols-1 flex gap-2 px-4 py-2 font-semibold'>
                            <div>Linked Devices</div>
                            <div>
                              <HelpTooltip
                                tooltipText={'Your linked devices'}
                                height='12px'
                              />
                            </div>
                          </div>
                          <div className='px-2 py-1'>
                            <button
                              onClick={handleAddDevice}
                              className='group relative py-1 w-32  border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                              // style={{ backgroundColor: "#5C6E64" }}
                            >
                              Add Device
                            </button>
                          </div>
                        </div>
                      )}

                      {/* dfns */}

                      {/* <div className='grid grid-cols-3'>
                        <div className='grid-cols-1 col-span-1 flex gap-2 px-4 py-2 font-semibold'>
                          <div>Identify yourself</div>
                          <div>
                            <HelpTooltip
                              tooltipText={
                                'Verify your identity with KYC  for security'
                              }
                              height='12px'
                            />
                          </div>
                        </div>
                        {status == 'ACTIVE' || status == 'REVIEWING' ? (
                          <></>
                        ) : (
                          <div className='px-2 py-1'>
                            {userProData.doc_submitted === true ? (
                              <CheckCircleIcon />
                            ) : (
                              <XCircleIcon />
                            )}
                          </div>
                        )}
                        <div className='-ml-12 lg:-ml-24 px-0 py-0'>
                          {userProData.doc_submitted === false ? (
                            <div>
                              {status == 'ACTIVE' || status == 'REVIEWING' ? (
                                <div className='py-1 mt-1 px-4 pl-28 italic '>
                                  Verifying...
                                </div>
                              ) : (
                                <button
                                  onClick={handleKyc}
                                  ref={kycButtonRef}
                                  className='group relative py-1 mt-2 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                                >
                                  KYC
                                </button>
                              )}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div> */}
                      {userProData.is_activated && (
                        <div>
                          <div className='flex gap-8 px-4 py-2 items-center font-semibold'>
                            <div>Account Status</div>
                            <p className='text-green-500 font-bold pl-8 mt-1 ml-1'>
                              Verified
                            </p>
                            {/* <div>
                            <HelpTooltip
                              tooltipText={
                                'Your account will be activated when you complete the above three actions'
                              }
                              height='12px'
                            />
                          </div> */}
                          </div>
                          {/* <div className='px-2 py-1'>
                          {userProData.is_activated === true ? (
                            <CheckCircleIcon />
                          ) : (
                            <>
                              <XCircleIcon />
                            </>
                          )}
                        </div> */}
                          <div className='px-0 py-0'>
                            {/* {!userProData.phoneNumberVerified &&
                          userProData.doc_submitted ? (
                            <button
                              onClick={() => setOpenAddNumberDialog(true)}
                              className='group relative py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                            >
                              Verify Phone
                            </button>
                          ) : null}
                          {userProData.phoneNumberVerified &&
                          !userProData.onRampMoneyKyc ? (
                            <p>This might take some time to verify...</p>
                          ) : null} */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {!userProData.is_activated || (wallet && !wallet.active) ? (
                <div className='flex justify-center'>
                  <div className='bg-white px-3 py-6 shadow-lg rounded-sm justify-center sw-shadow mx-14 md:mx-0 w-3/4 xl:w-2/5'>
                    <p className='text-center text-2xl pb-4'>
                      Complete your profile
                    </p>
                    <div className='md:py-8 ml-2 pt-4'>
                      <Stepper activeStep={stepperState} alternativeLabel>
                        {VerificationSteps.map((label) => (
                          <Step key={label}>
                            <StepLabel
                              StepIconProps={{
                                style: {
                                  width: 26,
                                  height: 26,
                                },
                              }}
                            >
                              <div className='text-xs lg:text-lg'>{label}</div>
                            </StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </div>
                    <div className='flex justify-center '>
                      {isButtonDisabled ? (
                        <button className='group relative py-3 mt-8 md:mt-1 px-5 text-md font-medium rounded-md text-white bg-gray-500'>
                          Verifying...
                        </button>
                      ) : wallet &&
                        !wallet.active &&
                        wallet.type === 'stellar' &&
                        !wallet.xlm_sent ? (
                        <button className='group relative py-3 mt-8 md:mt-1 px-5 text-md font-medium rounded-md text-white bg-gray-500'>
                          Creating
                        </button>
                      ) : (
                        <button
                          className='group relative py-3 mt-8 md:mt-1 px-5 text-md font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                          onClick={handleVerify}
                        >
                          Continue
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
            </>
          )}
        </div>
      )}
      <AddNumberDialogue
        open={openAddNumberDialog}
        handelClose={() => setOpenAddNumberDialog(false)}
        refetch={getUserProfileData}
      />
    </DashboardLayout>
  )
}

const AddNumberDialogue = ({ open, handelClose, refetch }) => {
  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [address, setAddress] = useState({
    addressLine: '',
    city: '',
    postalCode: '',
    country: '',
  })
  const [confirmationCode, setConfirmationCode] = useState(null)
  const [otp, setOtp] = useState('')

  const eurozoneISO = [
    'AT',
    'BE',
    'CY',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PT',
    'SK',
    'SI',
    'ES',
  ]

  const isValidCountry = (countryName) => {
    const code = getCode(countryName)
    return eurozoneISO.includes(code)
  }

  useEffect(() => {
    if (!open || confirmationCode) {
      return
    }
    try {
      const auth = getAuth(app)
      window.recaptchaVerifier = new RecaptchaVerifier(auth, 'sign-in-button', {
        size: 'invisible',
        callback: (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          console.log(response)
        },
      })
    } catch (error) {
      console.log({ error })
    }
  }, [open, confirmationCode])

  const handelAddNumber = async (code) => {
    try {
      setLoading(true)
      const { user } = await confirmationCode.confirm(code)
      const countryCode = parsePhoneNumber(user.phoneNumber).countryCallingCode
      const number = parsePhoneNumber(user.phoneNumber).nationalNumber
      const countryAlpha2Code = getCode(address.country)
      const idToken = await user.getIdToken()
      console.log({ user })
      const res = await axios.post(
        `${devURL}/user/addNumber/firebase`,
        {
          phoneNumber: `+${countryCode}-${number}`,
          addressLine: address.addressLine,
          city: address.city,
          postalCode: address.postalCode,
          country_code: countryAlpha2Code,
          firebaseToken: idToken,
        },
        {
          headers: { token: localStorage.getItem('swToken') },
        }
      )
      toast.success('OTP verified successfully.')
      setValue('')
      setOtp('')
      setConfirmationCode(null)
      handelClose()
      refetch()
      console.log(res.data)
    } catch (error) {
      console.log(error)
      if (error.code === 'auth/invalid-verification-code') {
        toast.error('Invalid OTP')
      } else {
        toast.error(
          error.response.data.message ||
            error.response.data.error ||
            'Something went wrong'
        )
      }
    } finally {
      setLoading(false)
    }
  }

  const handelSignIn = async () => {
    setLoading(true)
    if (!value || !isValidPhoneNumber(value)) {
      toast.error('Please enter a valid phone number')
      setLoading(false)
      return
    }

    if (!address.addressLine || !address.city || !address.postalCode) {
      toast.error('Please enter your address details')
      setLoading(false)
      return
    }

    const specialCharsRegexAddress = /[^a-zA-Z0-9 .,-]/
    const specialCharsRegex = /[^a-zA-Z0-9 ]/
    if (specialCharsRegexAddress.test(address.addressLine)) {
      toast.error(
        'Address line should not contain special characters other than ".-,"'
      )
      setLoading(false)
      return
    }

    if (specialCharsRegex.test(address.city || address.country)) {
      toast.error('Special characters are not allowed in city and country name')
      setLoading(false)
      return
    }

    if (!isValidCountry(address.country)) {
      toast.error('We only allow countries in the EuroZone or India currently')
      setLoading(false)
      return
    }
    try {
      const auth = getAuth(app)
      const confirmationCode = await signInWithPhoneNumber(
        auth,
        value,
        window.recaptchaVerifier
      )
      setConfirmationCode(confirmationCode)
    } catch (error) {
      console.log({ error })
      if (error.code === 'auth/invalid-phone-number') {
        toast.error('Invalid phone number')
      }
    } finally {
      setLoading(false)
    }
  }
  return (
    <Dialog
      open={open}
      onClose={() => {
        setConfirmationCode(null)
        handelClose()
      }}
      className='z-50'
    >
      <div className='fixed inset-0 bg-black/30' aria-hidden='true' />
      <div className='fixed inset-0 flex w-screen items-center justify-center p-4'>
        <Dialog.Panel className='bg-white py-4 px-6 rounded relative'>
          {/* close button */}
          <button
            onClick={() => {
              setConfirmationCode(null)
              handelClose()
            }}
            className='absolute top-2 right-3 text-xl'
          >
            &times;
          </button>

          {/* Phone Number input with country code */}

          {confirmationCode ? (
            <div className='min-w-[300px]'>
              <Dialog.Title className='text-center text-2xl font-bold text-gray-800 pt-3'>
                Verify OTP
              </Dialog.Title>
              <Dialog.Description className='text-center text-gray-600'>
                OTP sent to {value}
              </Dialog.Description>
              <form
                className='flex justify-center py-4 flex-col gap-2'
                onSubmit={(e) => {
                  e.preventDefault()
                  handelAddNumber(otp)
                }}
              >
                <input
                  value={otp}
                  onChange={(e) => {
                    // allow only numbers
                    const re = /^[0-9\b]+$/
                    if (e.target.value === '' || re.test(e.target.value)) {
                      setOtp(e.target.value)
                    }
                  }}
                  type='text'
                  className='appearance-none text-center relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                />
                <div className='flex justify-center '>
                  <button
                    className='border-red-500  text-red-500  py-2 px-4 rounded-md mr-4'
                    onClick={() => {
                      setOtp('')
                      setConfirmationCode(null)
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className='self-center bg-themeColor text-white py-2 px-4 rounded-md disabled:opacity-50'
                    type='submit'
                    disabled={loading}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <>
              <Dialog.Title className='text-center text-2xl font-bold text-gray-800 pt-3'>
                Add Phone Number
              </Dialog.Title>
              <Dialog.Description className='text-center text-gray-600'>
                Please add your phone number to verify your account
              </Dialog.Description>
              <div className='flex flex-col min-w-[350px]'>
                <PhoneInput
                  international
                  defaultCountry='DE'
                  countries={eurozoneISO}
                  className='flex py-4 px-4'
                  value={value}
                  onChange={(e) => setValue(e)}
                  countryCallingCodeEditable={false}
                />

                <Dialog.Title className='text-center text-2xl font-bold text-gray-800 pt-3'>
                  Add Address
                </Dialog.Title>
                <Dialog.Description className='text-center text-gray-600'>
                  Please enter your address to verify your account
                </Dialog.Description>
                <div className='my-4'>
                  <div className='col-span-2 px-4 py-2 grid grid-cols-1 gap-2'>
                    <input
                      name='addressLine'
                      placeholder='Address Line'
                      value={address.addressLine}
                      onChange={(e) =>
                        setAddress({ ...address, addressLine: e.target.value })
                      }
                      className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                    />
                    <input
                      name='city'
                      placeholder='City'
                      value={address.city}
                      onChange={(e) =>
                        setAddress({ ...address, city: e.target.value })
                      }
                      className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                    />
                    <input
                      name='postalCode'
                      placeholder='Postal Code'
                      value={address.postalCode}
                      onChange={(e) =>
                        setAddress({ ...address, postalCode: e.target.value })
                      }
                      className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                    />
                    <input
                      name='country'
                      placeholder='Country'
                      value={address.country}
                      onChange={(e) =>
                        setAddress({ ...address, country: e.target.value })
                      }
                      className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                    />
                  </div>
                </div>
                <button
                  className='bg-themeColor text-white h-12 px-4 rounded-md self-end disabled:opacity-50'
                  onClick={handelSignIn}
                  disabled={loading}
                  id='sign-in-button'
                >
                  {loading ? 'loading' : 'Send OTP'}
                </button>
              </div>
            </>
          )}
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}

export default MyProfile
